import { FiTrash } from '@react-icons/all-files/fi/FiTrash';
import { getPriceText } from '@zorba-shared/core/Services/textService';
import { InputNumber, Popconfirm } from 'antd';

export const getTableColumns = ({
  handleChange,
  editingKey,
  saveValue,
  handleCellClick,
  tempValue,
  handleDelete,
}) => [
  {
    title: 'Address',
    key: 'propertyAddress',
    render: ({ propertyAddress }) => propertyAddress,
  },
  {
    title: 'Asking Price',
    dataIndex: 'askingPrice',
    key: 'askingPrice',
    render: (_, record, index) =>
      editingKey === `${index}-askingPrice` ? (
        <InputNumber
          autoFocus
          value={tempValue}
          onChange={handleChange}
          onPressEnter={() => saveValue('askingPrice', index)}
          onBlur={() => saveValue('askingPrice', index)}
          formatter={(value) =>
            `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
          }
          parser={(value) => value.replace(/\$\s?|(,*)/g, '')}
        />
      ) : (
        <div
          className="editable-cell"
          onClick={() =>
            handleCellClick(index, 'askingPrice', record.askingPrice)
          }
        >
          {record.askingPrice ? `${getPriceText(record.askingPrice)}` : ''}
        </div>
      ),
  },
  {
    title: 'Beds',
    dataIndex: 'bedroom',
    key: 'bedroom',
    render: (_, record, index) =>
      editingKey === `${index}-bedroom` ? (
        <InputNumber
          autoFocus
          value={tempValue}
          onChange={handleChange}
          onPressEnter={() => saveValue('bedroom', index)}
          onBlur={() => saveValue('bedroom', index)}
          min={0}
        />
      ) : (
        <div
          className="editable-cell"
          onClick={() => handleCellClick(index, 'bedroom', record.bedroom)}
        >
          {record.bedroom != null ? record.bedroom : ''}
        </div>
      ),
  },
  {
    title: 'Baths',
    dataIndex: 'bathroom',
    key: 'bathroom',
    render: (_, record, index) =>
      editingKey === `${index}-bathroom` ? (
        <InputNumber
          autoFocus
          value={tempValue}
          onChange={handleChange}
          onPressEnter={() => saveValue('bathroom', index)}
          onBlur={() => saveValue('bathroom', index)}
          min={0}
        />
      ) : (
        <div
          className="editable-cell"
          onClick={() => handleCellClick(index, 'bathroom', record.bathroom)}
        >
          {record.bathroom != null ? record.bathroom : ''}
        </div>
      ),
  },
  {
    title: 'Year Built',
    dataIndex: 'yearBuilt',
    key: 'yearBuilt',
    render: (_, record, index) =>
      editingKey === `${index}-yearBuilt` ? (
        <InputNumber
          autoFocus
          value={tempValue}
          onChange={handleChange}
          onPressEnter={() => saveValue('yearBuilt', index)}
          onBlur={() => saveValue('yearBuilt', index)}
          min={1900}
          max={new Date().getFullYear()}
        />
      ) : (
        <div
          className="editable-cell"
          onClick={() => handleCellClick(index, 'yearBuilt', record.yearBuilt)}
        >
          {record.yearBuilt || ''}
        </div>
      ),
  },
  {
    title: '',
    key: 'actions',
    render: (_, __, index) => (
      <Popconfirm
        title="Are you sure you want to remove this record from the imported file?"
        onConfirm={() => handleDelete(index)}
        okText="Yes"
        cancelText="No"
      >
        <FiTrash style={{ cursor: 'pointer' }} />
      </Popconfirm>
    ),
  },
];
